import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

import api from "../../../api/api";
import {
  formatCalendarDate,
  setCaseId,
  setClientId,
  standardFormatDate,
} from "../../../Utils/helper";
import { fetchCaseSummary, fetchHeaderSummary } from "../../../api/case";
import {
  fetchAllPages,
  fetchCurrentCase,
  setCaseSummary,
} from "../../../Redux/caseData/caseDataSlice";
import { setHeaderName } from "../../../Redux/header_name/action";
import { setComponentLoadingEffect } from "../../../Redux/common/Loader/action";
import { setHeaderSummary } from "../../../Redux/header/headerDataSlice";
import "./expiry-statue.css";
import BirthdayIcon from "../../../assets/images/birthdayicon.svg";
import DOIIcon from "../../../assets/images/incident.svg";
import SOLIcon from "../../../assets/litigation/sol.svg";

import avatarImage from "./../../../assets/images/avatar.svg";
function getStyles() {
  return {
    height: window.innerWidth > 2300 ? "50px" : "50px",
    paddingTop: window.innerWidth > 2300 ? "0px" : "0px",
    paddingBottom: window.innerWidth > 2300 ? "0px" : "0px",
  };
}

const ExpireStatute = (_chats) => {
  const isValidName = (str) => {
    return str && str.trim().length > 0 && /[a-zA-Z]/.test(str.trim());
  };

  const origin = process.env.REACT_APP_BACKEND_URL;

  const [litigationActs, setLitigationActs] = useState([]);
  const [style, _setStyle] = useState({
    gap: window.innerWidth > 2300 ? "0px" : "0px",
    height: window.innerWidth > 2300 ? "50px" : "50px",
    flexDirection: window.innerWidth > 2300 ? "column" : "column",
    paddingTop: window.innerWidth > 2300 ? "5px" : "5px ",
    paddingBottom: window.innerWidth > 2300 ? "5px" : "5px",
    alignItems: window.innerWidth > 2300 ? "start" : "start",
    fontWeight: "600",
  });
  const [divStyle, setDivStyle] = useState({});
  const [initialStyle, setInitialStyle] = useState(getStyles());
  const [className, setClassName] = useState(getClassName());

  function getClassName() {
    return window.innerWidth > 2300 ? "paddingIssueinLeastAccess" : "";
  }

  useEffect(() => {
    const handleResize = () => {
      setClassName(getClassName());
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setInitialStyle(getStyles());
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // useEffect(() => {
  //   const handleResize = () => {
  //     setStyle({
  //       gap: window.innerWidth > 2300 ? "10px" : "0px",
  //       height: window.innerWidth > 2300 ? "25px" : "50px",
  //       flexDirection: window.innerWidth > 2300 ? "row" : "column",
  //       paddingTop: window.innerWidth > 2300 ? "0px !important" : "1px",
  //       paddingBottom: window.innerWidth > 2300 ? "0px !important" : "1px",
  //       alignItems: window.innerWidth > 2300 ? "center" : "start",
  //     });
  //   };

  //   window.addEventListener("resize", handleResize);
  //   return () => window.removeEventListener("resize", handleResize);
  // }, []);

  const calculateRowHeight = () => (window.innerWidth > 2300 ? 50 : 50);

  const calculateRowsToDisplay = () => {
    const rowHeight = calculateRowHeight();
    const height = tableRef.current.clientHeight;
    return Math.floor(height / rowHeight);
  };

  useEffect(() => {
    const handleResize = () => {
      const rowsToDisplay = calculateRowsToDisplay();
      const rowHeight = calculateRowHeight();
      setDivStyle({
        maxHeight: `${rowsToDisplay * rowHeight}px`,
        overflowY: "auto",
      });
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const fetchLitigationActs = async () => {
    try {
      const response = await api.get(`${origin}/api/homepage/expiring-statute/`);

      if (response.status === 200) {
        const data = response.data;

        setLitigationActs(data);
      }
    } catch (error) {
      console.error("Error fetching case types:", error);
    }
  };

  useEffect(() => {
    fetchLitigationActs();
  }, []);

  const changeCase = async (client_id, case_id) => {
    dispatch(setComponentLoadingEffect("medicalProviders", true));
    dispatch(setComponentLoadingEffect("detailBar", true));

    // eslint-disable-next-line unused-imports/no-unused-vars
    const response = await api.get(`/api/switch_client/${client_id}/${case_id}/1/`);

    setClientId(client_id);
    setCaseId(case_id);
    dispatch(fetchCurrentCase(client_id, case_id));

    fetchHeaderSummary(client_id, case_id)
      .then((data) => {
        dispatch(setHeaderSummary(data));
      })
      .catch(() => {});

    fetchCaseSummary(client_id, case_id)
      .then((data) => {
        dispatch(setCaseSummary(data));
        dispatch(fetchAllPages(case_id));
        dispatch(setHeaderName("Case"));

        navigate(`/bp-case/${client_id}/${case_id}`, {
          replace: true,
        });
      })
      .catch(() => {});
  };

  const renderedCases = new Set();
  const clientNameRefs = useRef([]);
  const [maxWidth, setMaxWidth] = useState("auto");
  const [_maxWidthForCaseType, setMaxWidthCaseType] = useState("auto");
  const caseTypeRefs = useRef([]);

  useEffect(() => {
    if (clientNameRefs.current.length > 0) {
      let calculatedMaxWidth = 0;
      clientNameRefs.current.forEach((ref) => {
        if (ref && ref.clientWidth > calculatedMaxWidth) {
          calculatedMaxWidth = ref.clientWidth;
        }
      });
      setMaxWidth(`${calculatedMaxWidth}px`);
    }
  }, [litigationActs]);
  useEffect(() => {
    if (caseTypeRefs.current.length > 0) {
      let calculatedMaxWidth = 0;
      caseTypeRefs.current.forEach((ref) => {
        if (ref && ref.clientWidth > calculatedMaxWidth) {
          calculatedMaxWidth = ref.clientWidth;
        }
      });
      setMaxWidthCaseType(`${calculatedMaxWidth}px`);
    }
  }, [litigationActs]);

  const [placeholderCount, setPlaceholderCount] = useState(0);
  const tableRef = useRef(null);

  const calculatePlaceholderCount = () => {
    if (tableRef.current) {
      const height = tableRef.current.clientHeight;
      const count = Math.floor(height / 50);
      setPlaceholderCount(count);
    }
  };

  useEffect(() => {
    // Calculate on mount
    calculatePlaceholderCount();

    // Recalculate on window resize
    window.addEventListener("resize", calculatePlaceholderCount);

    // Cleanup listener on unmount
    return () => {
      window.removeEventListener("resize", calculatePlaceholderCount);
    };
  }, []);
  // console.log(litigationActs);
  return (
    <div className="column order-1 order-xxl-2 d-flex flex-column m-b-5 column2">
      <div className="bg-primary-5 height-25">
        <h4 className="client-contact-title text-center height-25 d-flex justify-content-center align-items-center h-100 statute-lim">
          Expiring Statute of Limitations
        </h4>
      </div>

      {litigationActs.length > 0 ? (
        <div
          className="table-responsive table--no-card position-relative  border-0   flex-g-1"
          ref={tableRef}
          style={divStyle}
        >
          <table className="table table-expiry-statue  position-relative z-index-1 position-relative">
            <thead className="d-none">
              <tr>
                <th
                  style={{
                    width: "25px",
                    minWidth: "25px",
                    maxWidth: "25px",
                  }}
                />
                <th>Client</th>
                <th />
                <th />
                <th>S.O.L</th>
                <th
                  style={{
                    width: "5px",
                    minWidth: "5px",
                    maxWidth: "5px",
                  }}
                />
              </tr>
            </thead>
            <tbody>
              {litigationActs?.slice(0, calculateRowsToDisplay()).map((caseData, index) => {
                // eslint-disable-next-line no-unsafe-optional-chaining
                const { id, for_client, case_type, _incident_date } = caseData?.for_case;
                const { first_name, last_name, profile_pic_19p } = for_client || {};

                // Check if both first_name and last_name are valid (contains at least one letter after trimming)
                const isValidFirstName = isValidName(first_name);
                const isValidLastName = isValidName(last_name);

                // Create a unique identifier for the case using client name and case type
                const uniqueCaseIdentifier = `${first_name?.trim()} ${last_name?.trim()} - ${case_type?.name}`;

                // Only render the case if both first and last names are valid, and the case hasn't been rendered before
                if (
                  isValidFirstName &&
                  isValidLastName &&
                  !renderedCases.has(uniqueCaseIdentifier)
                ) {
                  // Mark this case as rendered by adding the unique identifier to the set
                  renderedCases.add(uniqueCaseIdentifier);

                  const renderClientName = `${first_name.trim()} ${last_name.trim()}`;
                  return (
                    <tr key={id} onClick={() => changeCase(for_client.id, id)}>
                      <td
                        id={`${className}`}
                        style={{
                          width: "25px",
                          maxWidth: "25px",
                          minWidth: "25px",
                          textAlign: "center",
                          color: "var(--primary-25)",
                          ...initialStyle,
                        }}
                        // scope="row"
                      >
                        {index + 1}
                      </td>

                      <td
                        className="text-black d-flex justify-content-center pt-0 pb-0"
                        style={{
                          ...style,
                          // maxWidth: maxWidth,
                        }}
                      >
                        <div className="d-flex height-21 align-items-center">
                          <span className="ic ic-avatar ic-15 has-avatar-icon has-cover-img bg-white">
                            <img
                              src={profile_pic_19p ?? avatarImage}
                              style={{
                                background: "var(--primary-30)",
                              }}
                              className="theme-ring"
                            />
                          </span>
                          <span
                            className="m-l-5 client-type text-start d-block align-items-center"
                            ref={(el) => (clientNameRefs.current[index] = el)}
                            style={{ width: maxWidth, fontWeight: "600" }}
                          >
                            {renderClientName}
                          </span>
                        </div>
                        <div className="case-type height-21 d-flex align-items-center font-weight-600 nowrap">
                          {case_type?.casetype_icon && (
                            <img src={case_type?.casetype_icon} className="m-r-5 ic-15" />
                          )}
                          {case_type?.name}
                        </div>
                      </td>
                      <td className="">
                        <div className="d-flex height-21 align-items-center font-weight-600 nowrap">
                          <img src={BirthdayIcon} className="m-r-5 ic-15" />
                          {caseData?.for_case?.for_client.birthday}
                        </div>
                        <div className="d-flex height-21 align-items-center font-weight-600 nowrap">
                          <img src={DOIIcon} className="m-r-5 ic-15" />
                          {formatCalendarDate(caseData?.for_case?.incident_date)}
                        </div>
                      </td>
                      <td className="">
                        {caseData?.for_defendant && (
                          <>
                            {" "}
                            <div className="d-flex height-21 align-items-center font-weight-600">
                              <img
                                src={
                                  "https://simplefirm-bucket.s3.amazonaws.com/static/images/defendants-icon-color_xdJ0JM3.svg"
                                }
                                className="m-r-5 ic-15"
                              />
                              <span
                                style={{
                                  display: "-webkit-box",
                                  WebkitLineClamp: 1,
                                  WebkitBoxOrient: "vertical",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  minWidth: "100px",
                                }}
                              >
                                {caseData?.for_defendant?.defendantType?.id === 1
                                  ? `${caseData?.for_defendant?.first_name} ${caseData?.for_defendant?.last_name}`
                                  : caseData?.for_defendant?.entity_name}
                              </span>
                            </div>
                            <div
                              className="d-flex height-21 align-items-center font-weight-600"
                              style={{
                                display: "-webkit-box",
                                WebkitLineClamp: 1,
                                WebkitBoxOrient: "vertical",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                minWidth: "100px",
                              }}
                            >
                              {caseData?.for_defendant?.defendantType?.name}
                            </div>
                          </>
                        )}
                      </td>
                      <td className=" text-end p-r-5" style={initialStyle} id={`${className}`}>
                        <div className="d-flex height-21 align-items-center justify-content-end font-weight-600 nowrap">
                          <img src={SOLIcon} className="m-r-5 ic-15" />
                          {caseData?.end_date && standardFormatDate(caseData?.end_date)}
                        </div>
                      </td>
                      <td
                        style={{
                          width: "5px",
                          minWidth: "5px",
                          maxWidth: "5px",
                        }}
                      />
                    </tr>
                  );
                } else {
                  const renderClientName = `${first_name.trim()} ${last_name.trim()}`;
                  return (
                    <tr
                      key={id}
                      onClick={() => changeCase(for_client.id, id)}
                      style={{ textAlign: "start" }}
                    >
                      <td
                        // scope="row"
                        id={`${className}`}
                        style={{
                          width: "25px",
                          maxWidth: "25px",
                          minWidth: "25px",
                          textAlign: "center",
                          color: "var(--primary-25)",
                          ...initialStyle,
                        }}
                      >
                        {index + 1}
                      </td>
                      <td
                        className="text-black d-flex justify-content-center pt-0 pb-0"
                        style={{
                          ...style,
                        }}
                      >
                        <div className="d-flex height-21 align-items-center">
                          <span className="ic ic-avatar ic-15 has-avatar-icon has-cover-img bg-white">
                            <img src={profile_pic_19p} className="theme-ring" />
                          </span>
                          <span
                            className="ms-2 client-type text-start d-block align-items-center"
                            ref={(el) => (clientNameRefs.current[index] = el)}
                            style={{ width: maxWidth }}
                          >
                            {renderClientName}
                          </span>
                        </div>
                        <div className="case-type height-21 d-flex align-items-center font-weight-600 nowrap">
                          {case_type?.casetype_icon && (
                            <img src={case_type?.casetype_icon} className="me-2 ic-15" />
                          )}
                          {case_type?.name}
                        </div>
                      </td>
                      <td
                        style={{
                          minWidth: "100px",
                        }}
                        className=""
                      >
                        <div className="d-flex height-21 align-items-center font-weight-600 nowrap">
                          <img src={BirthdayIcon} className="m-r-5 ic-15" />
                          {caseData?.for_case?.for_client.birthday}
                        </div>
                        <div className="d-flex height-21 align-items-center font-weight-600 nowrap">
                          <img src={DOIIcon} className="m-r-5 ic-15" />
                          {formatCalendarDate(caseData?.for_case?.incident_date)}
                        </div>
                      </td>
                      <td className="">
                        {caseData?.for_defendant && (
                          <>
                            {" "}
                            <div className="d-flex height-21 align-items-center font-weight-600 nowrap">
                              <img
                                src={
                                  "https://simplefirm-bucket.s3.amazonaws.com/static/images/defendants-icon-color_xdJ0JM3.svg"
                                }
                                className="m-r-5 ic-15"
                              />
                              {caseData?.for_defendant?.defendantType?.name}
                            </div>
                            <div className="d-flex height-21 align-items-center font-weight-600 nowrap">
                              {caseData?.for_defendant?.defendantType?.id === 1
                                ? `${caseData?.for_defendant?.first_name} ${caseData?.for_defendant?.last_name}`
                                : caseData?.for_defendant?.entity_name}
                            </div>
                          </>
                        )}
                      </td>
                      <td className=" text-end p-r-5" style={initialStyle} id={`${className}`}>
                        <div className="d-flex height-21 align-items-center justify-content-end font-weight-600 nowrap">
                          <img src={SOLIcon} className="m-r-5 ic-15" />
                          {caseData?.end_date && standardFormatDate(caseData?.end_date)}
                        </div>
                      </td>
                      <td
                        style={{
                          width: "5px",
                          minWidth: "5px",
                          maxWidth: "5px",
                        }}
                      />
                    </tr>
                  );
                }

                // If the case is already rendered or has invalid names, skip rendering this row
              })}
              {litigationActs.length < calculateRowsToDisplay() &&
                Array.from(
                  { length: calculateRowsToDisplay() - litigationActs.length },
                  (_, index) => (
                    <tr
                      style={{
                        height: "50px",
                      }}
                      key={`fake-${index}`}
                    >
                      <td className="" />
                      <td className=" text-black pb-0 pt-0 " />
                      <td className=" text-black pb-0 pt-0 " />
                      <td className=" text-black pb-0 pt-0 " />
                      <td className=" " />
                      <td />
                    </tr>
                  )
                )}
            </tbody>
          </table>
        </div>
      ) : (
        <div
          className="table-responsive table--no-card position-relative border-0 flex-g-1"
          ref={tableRef}
          style={divStyle}
        >
          <div className="home-tint-rows">
            {Array.from({ length: placeholderCount || 750 / 50 }).map((_, i) => (
              <div
                key={i}
                style={{
                  height: "50px",
                }}
              />
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default ExpireStatute;
